import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";
import { VisitCompletionRule } from "@app/models/rest/visit-completion-rule";
import { VisitCompletionRuleRestService } from "@app/services/hal/visit-completion-rule-rest.service";

@Injectable({ providedIn: "root" })
export class VisitCompletionRuleStore extends RealTimeDataStore<VisitCompletionRule> {
  constructor() {
    const visitCompletionRuleRestService = inject(
      VisitCompletionRuleRestService
    );
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(
      visitCompletionRuleRestService,
      webStompSubscriber,
      hateoasResourceService
    );
    super.subscribeToMessaging("VisitCompletionRule");
  }
}
